import { render } from "./FeesComponent.vue?vue&type=template&id=2a182bfa"
import script from "./FeesComponent.vue?vue&type=script&lang=js"
export * from "./FeesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Local Sites/heritage-af3/app/public/wp-content/plugins/af3-shortcodes-1.2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__